import { createBreakpoint } from 'react-use';
import { viewportSizes } from '@tymate/margaret';

export const useBreakpoint = createBreakpoint({
  loading: 0,
  mobile: 1,
  ...viewportSizes,
});
